import {
  CHECKOUT_HANDOFF_KEYS,
  isAdTrackingParam,
} from 'lib/analytics/checkoutAttributes';
import { allowsAds } from 'lib/consent/gate';
import type { CartLineAttribute } from 'lib/commerce/cart/types';

/** Allowlisted campaign / partner params from the current URL, gated on consent at call time. */
export function readUrlCartParams(): CartLineAttribute[] {
  if (typeof window === 'undefined') return [];
  const params = new URLSearchParams(window.location.search);
  const ads = allowsAds();
  const attributes: CartLineAttribute[] = [];
  for (const key of CHECKOUT_HANDOFF_KEYS) {
    const value = params.get(key);
    if (!value) continue;
    if (!ads && isAdTrackingParam(key)) continue;
    attributes.push({ key, value });
  }
  return attributes;
}
